export default "__VITE_ASSET__BMxhWJ6s__"